<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-divider type="vertical" class="item" />

                <a-radio-group v-model="status" button-style="solid" @change="(e) => on_field_change(e, 'status')" style="margin-right:8px">
                    <a-radio-button value>全部</a-radio-button>
                    <a-radio-button value="1">通过</a-radio-button>
                    <a-radio-button value="-1">拒绝</a-radio-button>
                </a-radio-group>

                <a-radio-group v-model="type" button-style="solid" @change="(e) => on_field_change(e, 'type')">
                    <a-radio-button value>全部</a-radio-button>
                    <a-radio-button value="receipt">收据</a-radio-button>
                    <a-radio-button value="special">增值税专业发票</a-radio-button>
                    <a-radio-button value="normal">增值税普通发票</a-radio-button>
                </a-radio-group>
            </div>

            <div class="right-items">
                <a-input-search
                    placeholder="搜索公司名称"
                    enter-button
                    @search="on_search"
                    class="item"
                    v-model="wd"
                />
            </div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                size="middle"
            >
                <template slot="sort" slot-scope="text, record, index">
                    <div class="sort">
                        <a-button
                            shape="circle"
                            icon="arrow-down"
                            size="small"
                            @click="on_sort(record, 'down', index)"
                            v-if="index != data_source.length - 1"
                        />
                        <a-button shape="circle" icon="arrow-up" size="small" @click="on_sort(record, 'up', index)" v-if="index != 0" />
                    </div>
                </template>

                <template slot="status" slot-scope="text, record">
                    <a-tag class="b-tag" v-if="text == 0">处理中</a-tag>
                    <a-tag color="green" class="b-tag" v-if="text == 1">通过</a-tag>
                    <a-tag color="red" class="b-tag" v-if="text == -1">拒绝</a-tag>
                </template>

                <template slot="license" slot-scope="text, record">
                    <a v-if="text" :href="text" target="_blank">查看</a>
                </template>

                 <template slot="auditor" slot-scope="text, record">
                     <div class="tb-c1" v-if="record.audited_at">
                         <div class="item">{{record.auditor.name}}</div>
                         <div class="item">{{ moment(record.audited_at * 1000).format("YYYY-MM-DD HH:mm") }}</div>
                     </div>
                </template>

                <template slot="company" slot-scope="text, record">
                    <table class="b-table">
                        <tbody>
                            <tr>
                                <td width="80px">抬头</td>
                                <td>{{ record.title }}</td>
                            </tr>
                            <template v-if="record.invoice_type != 'receipt'">
                                <tr>
                                    <td>纳税人识别码</td>
                                    <td>{{ record.id_code }}</td>
                                </tr>
                                <tr>
                                    <td>开户行</td>
                                    <td>{{ record.bank_name }}</td>
                                </tr>
                                <tr>
                                    <td>开户行账号</td>
                                    <td>{{ record.bank_no }}</td>
                                </tr>
                                <tr>
                                    <td>地址</td>
                                    <td>{{ record.reg_address }}</td>
                                </tr>
                            </template>

                            <tr>
                                <td>电话</td>
                                <td>{{ record.tel }}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>

                <!-- 操作 -->
                <template slot="action" slot-scope="text, record">
                    <div class="operation">
                        <a-button size="small" style="margin-bottom: 4px" @click="on_audit(record,1)">通过</a-button>
                        <a-button size="small" style="margin-bottom: 4px" @click="on_audit(record,-1)">拒绝</a-button>
                        <a-button size="small" @click="on_edit(record)">修改</a-button>
                    </div>
                </template>
            </a-table>
        </div>

        <!-- 修改 -->
        <modal_edit :visible="visible_edit" @close="visible_edit = false" :record="selected_record" :callback="load" />

        <!-- 审核 -->
        <modal_audit :visible="visible_audit" @close="visible_audit = false" :record="selected_record" :callback="load" :audit_status="audit_status"/>
    </div>
</template>

<script>
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";
    import modal_edit from "./modal_edit.vue";
    import modal_audit from "./modal_audit.vue";
    export default {
        mixins: [common_pagination],
        components: { modal_edit, modal_audit },
        data() {
            return {
                path: "/finance/invoice_review",
                data_source: [],
                loading: false,
                visible_edit: false,
                visible_audit:false,
                selected_record: null,
                wd: null,
                status: "",
                type: "",
                audit_status:null,
                data_summary: {
                    amount: 0,
                    amount_pend: 0,
                    amount_succeed: 0,
                },
                columns: [
                    {
                        dataIndex: "invoice_status",
                        width: 70,
                        title: "状态",
                        scopedSlots: {
                            customRender: "status",
                        },
                    },
                    {
                        dataIndex: "member.name",
                        width: 120,
                        title: "客户信息",
                    },
                    {
                        dataIndex: "invoice_type_text",
                        width: 100,
                        title: "发票类型",
                    },
                    {
                        dataIndex: "company",
                        title: "开票信息",
                        scopedSlots: {
                            customRender: "company",
                        },
                    },
                    {
                        dataIndex: "license",
                        width: 80,
                        title: "营业执照",
                        scopedSlots: {
                            customRender: "license",
                        },
                    },
                    {
                        dataIndex: "invoice_applied_at",
                        width: 100,
                        title: "申请时间",
                        customRender: (e) => (e ? moment(e * 1000).format("YYYY-MM-DD HH:mm") : ""),
                    },

                    {
                        dataIndex: "auditor.name",
                        width: 100,
                        title: "审核人",
                        scopedSlots: {
                            customRender: "auditor",
                        },
                    },
                    {
                        dataIndex: "invoice_msg",
                        width: 120,
                        title: "审核信息",
                    },
                    {
                        dataIndex: "action",
                        width: 80,
                        align: "center",
                        title: "操作",
                        scopedSlots: {
                            customRender: "action",
                        },
                    },
                ],
            };
        },
        mounted() {
            this.load();

            // this.load_summary();
        },
        watch: {
            $route() {
                this.load();
            },
        },
        methods: {
            moment,
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/finance/invoice_review?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            load_summary() {
                this.$http
                    .get(`/finance/invoice_review/summary`)
                    .then((res) => {
                        if (res.success) {
                            this.data_summary = res.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            on_field_change(e, field) {
                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                new_query[field] = e.target.value;
                this.$router.push(this.path + "?" + this.objectToQuery(new_query));
            },
            on_edit(item) {
                this.selected_record = item;
                this.visible_edit = true;
            },
            on_audit(item,status){
                this.selected_record = item;
                this.visible_audit = true;
                this.audit_status = status
            }
        },
    };
</script>

<style lang="less" scoped>
    .summary {
        padding: 16px;
        border-bottom: 1px solid #e8e8e8;
        box-sizing: border-box;
        display: flex;
        align-items: center;
    }
</style>
